"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BackgroundImage = function (_React$Component) {
  (0, _inherits3.default)(BackgroundImage, _React$Component);

  function BackgroundImage() {
    (0, _classCallCheck3.default)(this, BackgroundImage);
    return (0, _possibleConstructorReturn3.default)(this, (BackgroundImage.__proto__ || (0, _getPrototypeOf2.default)(BackgroundImage)).apply(this, arguments));
  }

  (0, _createClass3.default)(BackgroundImage, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          src = _props.src,
          altText = _props.altText,
          className = _props.className;
      var imageStyle = src && {
        backgroundImage: "url(" + src + ")"
      };
      return (0, _jsx3.default)("div", {
        style: imageStyle,
        "aria-label": altText,
        className: className
      });
    }
  }]);
  return BackgroundImage;
}(_react2.default.Component);

BackgroundImage.propTypes = {
  className: _propTypes2.default.string,
  altText: _propTypes2.default.string,
  src: _propTypes2.default.string
};
exports.default = BackgroundImage;